export const BACKEND_DATA_STRUCTURE = {
    "houses": [],
    "pages": []
};